import $ from 'jquery';

const menuButton = document.querySelectorAll('.navbar-main .submenu-toggle');
if (menuButton) {
  $( document ).ready(function( $ ) {
    menuButton.forEach((elm) => {
      elm.addEventListener('click', (e) => {
        e.preventDefault();
        $(e.target).parents('.subs').addClass('open-subs');
      });
    });

    document.addEventListener('keyup', (e) => {
      let closeSubs = false;
      if (e.key == 'Escape') {
        closeSubs = true;
      } else if (e.key == 'Tab'){
        if ($(e.target).parents('.open-subs').length === 0) {
          closeSubs = true;
        }
      }

      if (closeSubs) {
        closeMainMenuSubs();
      }
    });
    document.addEventListener('click', (e) => {
      if ($(e.target).parents('.open-subs').length === 0) {
        closeMainMenuSubs();
      }
    });
  });

  document.querySelector('.navbar-main').addEventListener('mouseleave', (e) => {
    if ($('.navbar-main .subs.open-subs').length > 0) {
      closeMainMenuSubs();
    }
  });
  document.querySelector('main').addEventListener('mousemove', (e) => {
    if ($('.navbar-main .subs.open-subs').length > 0) {
      closeMainMenuSubs();
    }
  });
}

function closeMainMenuSubs() {
  $('.navbar-main .subs.open-subs').removeClass('open-subs');
}
